export const INVITE_THEMES = [
  {
    id: "classic-professional",
    name: "Classic Professional",
    description: "Clean, polished, and versatile for most celebrations.",
    status: "active",
    sortOrder: 10,
    eventTypes: ["wedding", "birthday", "corporate", "graduation", "housewarming"],
    recommendedFor: ["corporate", "graduation"],
    compatibleWith: ["wedding", "birthday", "corporate", "graduation", "housewarming", "cultural_programs"],
    allowCrossEventUse: true,
    styleTags: ["clean", "modern", "professional"],
    toneTags: ["formal", "modern", "corporate"],
    moodTags: ["minimal", "calm"],
    featureTags: ["video_hero", "rsvp", "comments", "gallery"],
    componentKey: "classic-landing",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#eef2f8",
      backgroundAlt: "#f8fbff",
      surface: "#ffffff",
      surfaceSoft: "#f5f8fc",
      accent: "#31598b",
      accentAlt: "#1c3557",
      text: "#162030",
      muted: "#5a6779",
      border: "rgba(152, 170, 195, 0.24)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "clean",
    },
  },
  {
    id: "royal-wedding",
    name: "Royal Wedding",
    description: "Grand, cinematic, and ideal for luxurious wedding storytelling.",
    status: "active",
    sortOrder: 20,
    eventTypes: ["wedding", "engagement"],
    recommendedFor: ["wedding", "engagement"],
    compatibleWith: ["wedding", "engagement", "cultural_programs"],
    allowCrossEventUse: true,
    styleTags: ["royal", "cinematic", "traditional", "premium"],
    toneTags: ["formal", "luxury", "family"],
    moodTags: ["royal", "festive", "warm"],
    featureTags: ["video_hero", "subevents", "rsvp", "gallery", "comments"],
    componentKey: "royal-experience",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#2b0d17",
      backgroundAlt: "#4b1830",
      surface: "#fff7ea",
      surfaceSoft: "#fbefe0",
      accent: "#d9b36a",
      accentAlt: "#a87a2d",
      text: "#3d151f",
      muted: "#7f665f",
      border: "rgba(169, 122, 45, 0.28)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "ornamental",
    },
  },
  {
    id: "minimal-ivory",
    name: "Minimal Ivory",
    description: "Airy, elegant, and highly readable for refined gatherings.",
    status: "active",
    sortOrder: 30,
    eventTypes: ["wedding", "engagement", "baby_shower", "housewarming"],
    recommendedFor: ["engagement", "housewarming"],
    compatibleWith: ["wedding", "engagement", "baby_shower", "birthday", "housewarming", "corporate"],
    allowCrossEventUse: true,
    styleTags: ["minimal", "elegant", "soft"],
    toneTags: ["formal", "family", "modern"],
    moodTags: ["minimal", "calm", "elegant"],
    featureTags: ["video_hero", "rsvp", "venue", "minimal"],
    componentKey: "classic-landing",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#f5efe5",
      backgroundAlt: "#fffaf1",
      surface: "#fffdf7",
      surfaceSoft: "#f3eadb",
      accent: "#a1763a",
      accentAlt: "#6f5533",
      text: "#2d241a",
      muted: "#776a5b",
      border: "rgba(161, 118, 58, 0.24)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "minimal",
    },
  },
  {
    id: "soft-white-light",
    name: "Soft White Light",
    description: "Simple, bright, and soft white so darker invitation videos remain the hero.",
    status: "active",
    sortOrder: 35,
    eventTypes: ["wedding", "engagement", "birthday", "baby_shower", "housewarming", "cultural_programs"],
    recommendedFor: ["wedding", "cultural_programs", "housewarming"],
    compatibleWith: [
      "wedding",
      "engagement",
      "birthday",
      "baby_shower",
      "housewarming",
      "cultural_programs",
      "graduation",
      "corporate",
    ],
    allowCrossEventUse: true,
    styleTags: ["light", "simple", "airy", "elegant"],
    toneTags: ["family", "modern", "warm"],
    moodTags: ["calm", "bright", "minimal"],
    featureTags: ["video_hero", "rsvp", "comments", "gallery"],
    componentKey: "classic-landing",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#fbfaf7",
      backgroundAlt: "#f1eee8",
      surface: "#ffffff",
      surfaceSoft: "#f7f4ee",
      accent: "#c58a3a",
      accentAlt: "#7f5b35",
      text: "#27221c",
      muted: "#746e66",
      border: "rgba(126, 100, 68, 0.16)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "minimal",
    },
  },
  {
    id: "floral-pastel",
    name: "Floral Pastel",
    description: "Soft blooms and gentle color for showers, weddings, and birthdays.",
    status: "active",
    sortOrder: 40,
    eventTypes: ["baby_shower", "wedding", "birthday", "engagement"],
    recommendedFor: ["baby_shower"],
    compatibleWith: ["baby_shower", "wedding", "birthday", "engagement", "housewarming"],
    allowCrossEventUse: true,
    styleTags: ["floral", "pastel", "soft"],
    toneTags: ["family", "modern"],
    moodTags: ["floral", "warm", "calm"],
    featureTags: ["video_hero", "rsvp", "gallery", "guest_media"],
    componentKey: "classic-landing",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#fff1f5",
      backgroundAlt: "#f6f8e8",
      surface: "#ffffff",
      surfaceSoft: "#fff8fb",
      accent: "#c85f87",
      accentAlt: "#8f4d69",
      text: "#33212a",
      muted: "#765a66",
      border: "rgba(200, 95, 135, 0.22)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "floral",
    },
  },
  {
    id: "bollywood-glam",
    name: "Bollywood Glam",
    description: "Bold, colorful, and dramatic for high-energy celebrations.",
    status: "active",
    sortOrder: 50,
    eventTypes: ["wedding", "birthday", "engagement"],
    recommendedFor: ["birthday"],
    compatibleWith: ["wedding", "birthday", "engagement", "cultural_programs"],
    allowCrossEventUse: true,
    styleTags: ["bold", "cinematic", "glam"],
    toneTags: ["family", "luxury"],
    moodTags: ["festive", "bold", "playful"],
    featureTags: ["video_hero", "gallery", "comments", "guest_media"],
    componentKey: "classic-landing",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#22072f",
      backgroundAlt: "#5f0f6f",
      surface: "#fff7ee",
      surfaceSoft: "#ffe6f4",
      accent: "#ffb000",
      accentAlt: "#e53d8f",
      text: "#2e102f",
      muted: "#70516f",
      border: "rgba(255, 176, 0, 0.28)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "glam",
    },
  },
  {
    id: "temple-gold",
    name: "Temple Gold",
    description: "Devotional gold styling for pujas, festivals, and cultural programs.",
    status: "active",
    sortOrder: 60,
    eventTypes: ["cultural_programs", "housewarming"],
    recommendedFor: ["cultural_programs"],
    compatibleWith: ["cultural_programs", "housewarming", "wedding"],
    allowCrossEventUse: true,
    styleTags: ["devotional", "traditional", "gold"],
    toneTags: ["devotional", "community", "traditional"],
    moodTags: ["warm", "festive", "calm"],
    featureTags: ["video_hero", "schedule", "venue", "comments"],
    componentKey: "classic-landing",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#4a1208",
      backgroundAlt: "#8a340d",
      surface: "#fff6dc",
      surfaceSoft: "#ffe9aa",
      accent: "#e7a927",
      accentAlt: "#b54c1d",
      text: "#3a1608",
      muted: "#765034",
      border: "rgba(231, 169, 39, 0.3)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "ornamental",
    },
  },
  {
    id: "marigold-festival",
    name: "Marigold Festival",
    description: "Saffron, marigold, and community celebration styling.",
    status: "active",
    sortOrder: 70,
    eventTypes: ["cultural_programs"],
    recommendedFor: ["cultural_programs"],
    compatibleWith: ["cultural_programs", "wedding", "housewarming"],
    allowCrossEventUse: true,
    styleTags: ["festival", "marigold", "traditional"],
    toneTags: ["community", "devotional", "family"],
    moodTags: ["festive", "warm", "bold"],
    featureTags: ["video_hero", "schedule", "comments", "gallery"],
    componentKey: "classic-landing",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#7a2308",
      backgroundAlt: "#f1a51d",
      surface: "#fff8dc",
      surfaceSoft: "#ffe7a8",
      accent: "#f28c18",
      accentAlt: "#c13512",
      text: "#3b1506",
      muted: "#7a4b24",
      border: "rgba(242, 140, 24, 0.28)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "festival",
    },
  },
  {
    id: "kids-birthday-pop",
    name: "Kids Birthday Pop",
    description: "Bright, playful, and perfect for short birthday invites.",
    status: "active",
    sortOrder: 80,
    eventTypes: ["birthday"],
    recommendedFor: ["birthday"],
    compatibleWith: ["birthday", "baby_shower"],
    allowCrossEventUse: true,
    styleTags: ["kids", "playful", "bright"],
    toneTags: ["kids", "family"],
    moodTags: ["playful", "bold", "festive"],
    featureTags: ["video_hero", "rsvp", "gallery", "guest_media"],
    componentKey: "classic-landing",
    isFeatured: true,
    isPremium: false,
    tokens: {
      background: "#e9f7ff",
      backgroundAlt: "#fff1b8",
      surface: "#ffffff",
      surfaceSoft: "#f3fbff",
      accent: "#ff6b6b",
      accentAlt: "#3485ff",
      text: "#17223b",
      muted: "#627089",
      border: "rgba(52, 133, 255, 0.2)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "playful",
    },
  },
  {
    id: "elegant-birthday",
    name: "Elegant Birthday",
    description: "Premium dinner-party feel for milestone birthday celebrations.",
    status: "active",
    sortOrder: 90,
    eventTypes: ["birthday"],
    recommendedFor: ["birthday"],
    compatibleWith: ["birthday", "corporate", "engagement"],
    allowCrossEventUse: true,
    styleTags: ["elegant", "modern", "premium"],
    toneTags: ["luxury", "modern", "formal"],
    moodTags: ["elegant", "warm", "minimal"],
    featureTags: ["video_hero", "rsvp", "venue", "gallery"],
    componentKey: "classic-landing",
    isFeatured: false,
    isPremium: false,
    tokens: {
      background: "#151515",
      backgroundAlt: "#47321c",
      surface: "#fff8ee",
      surfaceSoft: "#f4eadb",
      accent: "#c89b5f",
      accentAlt: "#8f6238",
      text: "#241811",
      muted: "#6a594c",
      border: "rgba(200, 155, 95, 0.28)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "minimal",
    },
  },
  {
    id: "corporate-slate",
    name: "Corporate Slate",
    description: "Sharp and structured for company events, seminars, and launches.",
    status: "active",
    sortOrder: 100,
    eventTypes: ["corporate"],
    recommendedFor: ["corporate"],
    compatibleWith: ["corporate", "graduation"],
    allowCrossEventUse: true,
    styleTags: ["corporate", "minimal", "modern"],
    toneTags: ["corporate", "formal", "modern"],
    moodTags: ["minimal", "calm"],
    featureTags: ["video_hero", "schedule", "venue", "rsvp", "minimal"],
    componentKey: "classic-landing",
    isFeatured: false,
    isPremium: false,
    tokens: {
      background: "#0f172a",
      backgroundAlt: "#334155",
      surface: "#f8fafc",
      surfaceSoft: "#e2e8f0",
      accent: "#38bdf8",
      accentAlt: "#2563eb",
      text: "#0f172a",
      muted: "#475569",
      border: "rgba(56, 189, 248, 0.22)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "clean",
    },
  },
  {
    id: "graduation-modern",
    name: "Graduation Modern",
    description: "Achievement-focused layout with crisp celebratory energy.",
    status: "active",
    sortOrder: 110,
    eventTypes: ["graduation"],
    recommendedFor: ["graduation"],
    compatibleWith: ["graduation", "corporate", "birthday"],
    allowCrossEventUse: true,
    styleTags: ["modern", "achievement", "clean"],
    toneTags: ["family", "modern", "formal"],
    moodTags: ["bold", "minimal", "warm"],
    featureTags: ["video_hero", "rsvp", "gallery", "venue"],
    componentKey: "classic-landing",
    isFeatured: false,
    isPremium: false,
    tokens: {
      background: "#102a43",
      backgroundAlt: "#f4c430",
      surface: "#ffffff",
      surfaceSoft: "#edf6ff",
      accent: "#f4c430",
      accentAlt: "#1f6feb",
      text: "#102a43",
      muted: "#52606d",
      border: "rgba(31, 111, 235, 0.2)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "clean",
    },
  },
  {
    id: "housewarming-warm",
    name: "Housewarming Warm",
    description: "Cozy, family-first styling for new homes and blessings.",
    status: "active",
    sortOrder: 120,
    eventTypes: ["housewarming"],
    recommendedFor: ["housewarming"],
    compatibleWith: ["housewarming", "cultural_programs", "baby_shower"],
    allowCrossEventUse: true,
    styleTags: ["warm", "family", "cozy"],
    toneTags: ["family", "traditional", "community"],
    moodTags: ["warm", "calm", "elegant"],
    featureTags: ["video_hero", "venue", "rsvp", "comments"],
    componentKey: "classic-landing",
    isFeatured: false,
    isPremium: false,
    tokens: {
      background: "#fff2dd",
      backgroundAlt: "#d98b45",
      surface: "#fffaf2",
      surfaceSoft: "#ffe9ca",
      accent: "#b65f2a",
      accentAlt: "#8a3f1f",
      text: "#321b10",
      muted: "#74533f",
      border: "rgba(182, 95, 42, 0.24)",
      headingFont: "Georgia, Times New Roman, serif",
      frameStyle: "warm",
    },
  },
];

export const INVITE_REVEALS = [
  {
    id: "curtain-open",
    name: "Curtain Open",
    description: "Two panels part to reveal the invitation, ideal for grand events.",
    recommendedFor: ["wedding", "engagement", "cultural_programs"],
    styleTags: ["royal", "cinematic", "traditional"],
  },
  {
    id: "soft-fade",
    name: "Soft Fade",
    description: "A gentle fade-in for elegant, minimal, or professional invites.",
    recommendedFor: ["corporate", "graduation", "housewarming"],
    styleTags: ["minimal", "modern", "calm"],
  },
  {
    id: "golden-glow",
    name: "Golden Glow",
    description: "Warm light blooms around the video before the details settle in.",
    recommendedFor: ["cultural_programs", "housewarming", "wedding"],
    styleTags: ["devotional", "warm", "festival"],
  },
  {
    id: "confetti-pop",
    name: "Confetti Pop",
    description: "Playful dots and color bursts for birthdays and casual celebrations.",
    recommendedFor: ["birthday", "baby_shower"],
    styleTags: ["playful", "kids", "bright"],
  },
  {
    id: "spotlight-rise",
    name: "Spotlight Rise",
    description: "A cinematic spotlight lifts upward to reveal the invitation.",
    recommendedFor: ["wedding", "engagement", "birthday", "corporate"],
    styleTags: ["cinematic", "modern", "premium"],
  },
  {
    id: "floral-bloom",
    name: "Floral Bloom",
    description: "Soft floral corners bloom in before the invitation settles.",
    recommendedFor: ["wedding", "baby_shower", "birthday", "housewarming"],
    styleTags: ["floral", "soft", "elegant"],
  },
  {
    id: "slide-up-card",
    name: "Slide Up Card",
    description: "The invitation card slides up cleanly from the bottom.",
    recommendedFor: ["corporate", "graduation", "housewarming", "birthday"],
    styleTags: ["minimal", "modern", "clean"],
  },
  {
    id: "sparkle-frame",
    name: "Sparkle Frame",
    description: "A glowing frame draws around the invitation with subtle sparkles.",
    recommendedFor: ["wedding", "engagement", "cultural_programs", "birthday"],
    styleTags: ["festive", "premium", "warm"],
  },
  {
    id: "balloon-float",
    name: "Balloon Float",
    description: "Colorful balloons float upward before revealing the invitation.",
    recommendedFor: ["birthday", "baby_shower", "graduation"],
    styleTags: ["playful", "kids", "bright"],
  },
  {
    id: "petal-blessing",
    name: "Petal Blessing",
    description: "Auspicious flower petals drift down like a ceremonial blessing.",
    recommendedFor: ["cultural_programs", "wedding", "engagement", "housewarming"],
    styleTags: ["devotional", "auspicious", "floral", "festival"],
  },
];

const normalize = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

export const getActiveInviteThemes = () =>
  INVITE_THEMES.filter((theme) => theme.status === "active").sort(
    (a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)
  );

export const getInviteThemeById = (themeId) =>
  getActiveInviteThemes().find((theme) => theme.id === themeId) || getActiveInviteThemes()[0];

export const getInviteRevealById = (revealId) =>
  INVITE_REVEALS.find((reveal) => reveal.id === revealId) || INVITE_REVEALS[0];

export const getThemeFit = (theme, eventType) => {
  const normalizedEventType = normalize(eventType);
  if (!normalizedEventType) return "all";
  if ((theme.recommendedFor || []).map(normalize).includes(normalizedEventType)) {
    return "recommended";
  }
  if ((theme.compatibleWith || []).map(normalize).includes(normalizedEventType)) {
    return "compatible";
  }
  return theme.allowCrossEventUse ? "cross_event" : "restricted";
};

export const getThemeStyleVars = (theme) => {
  const tokens = theme?.tokens || {};
  return {
    "--theme-bg": tokens.background,
    "--theme-bg-alt": tokens.backgroundAlt,
    "--theme-surface": tokens.surface,
    "--theme-surface-soft": tokens.surfaceSoft,
    "--theme-accent": tokens.accent,
    "--theme-accent-alt": tokens.accentAlt,
    "--theme-text": tokens.text,
    "--theme-muted": tokens.muted,
    "--theme-border": tokens.border,
    "--theme-heading-font": tokens.headingFont,
  };
};

export const normalizeEventTypeName = normalize;
